"use client";

import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import BackSvg from "public/img/back-button.svg";

export default function BackButton() {
  const pathname = usePathname();
  const { back } = useRouter();
  const isRoot = pathname.endsWith("/employee-offer");

  return isRoot ? (
    <div className="h-10 w-10"></div>
  ) : (
    <button
      onClick={() => back()}
      aria-label="Back button"
      className="cursor-pointer"
      tabIndex={0}
    >
      <Image src={BackSvg} width={40} height={40} alt="" />
    </button>
  );
}
